import { AdditionalCostCategoryModel } from './additional-cost-category-model';

export class AdditionalCostModel {
  public additionalCostsId: number;
  public fkAuditReportId: string;
  public categoryDTO: AdditionalCostCategoryModel;
  public comment: string;
  public additionalCost: number;
  public signatureValid: boolean;

  public constructor(
    additionalCostsId?: number,
    fkAuditReportId?: string,
    categoryDTO?: AdditionalCostCategoryModel,
    comment?: string,
    additionalCost?: number,
    signatureValid?: boolean,
  ) {
    this.additionalCostsId = additionalCostsId;
    this.fkAuditReportId = fkAuditReportId;
    this.categoryDTO = categoryDTO;
    this.comment = comment;
    this.additionalCost = additionalCost;
    this.signatureValid = signatureValid;
  }
}
